import React, { useEffect } from 'react';

export default function Modal({ children, onClose }) {
  // Lock background page scroll on mobile while this modal is mounted.
  // Uses the same 1024px breakpoint the rest of the app treats as the
  // mobile/desktop split (see public/bmk-react.scss). On mobile, `overflow: hidden`
  // alone doesn't stop touch-scroll from bleeding through to the body on iOS
  // Safari, so we also fix the body in place at its current scroll offset and
  // restore that exact position on close (see `.scroll-locked` in bmk-react.scss).
  useEffect(() => {
    const scrollY = window.scrollY || window.pageYOffset;
    document.body.style.setProperty('--scroll-lock-offset', `-${scrollY}px`);
    document.body.classList.add('scroll-locked');

    return () => {
      document.body.classList.remove('scroll-locked');
      document.body.style.removeProperty('--scroll-lock-offset');
      window.scrollTo(0, scrollY);
    };
  }, []);

  return (
    <div id="modalSeriesDetails" className="modal modalSeriesDetails show" tabIndex="-1" role="dialog" aria-modal="true">
      <div className="modal-backdrop" onClick={onClose}></div>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <button type="button" className="close modal-close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
            <span aria-hidden="true">x</span>
          </button>
          <div className="modal-body config-validation mt-10">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}